// extracted by mini-css-extract-plugin
module.exports = {"freebet-wrapper":"liveList__freebet-wrapper___2Xc3k"};